import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import "../screens/User/Home/Home.css";
import Typed from "react-typed";
import PropTypes from "prop-types";
import "bootstrap/dist/css/bootstrap.css";
import elabsImage from "../images/smartmockups_kl7ie8ha.jpg";
import upnmImage from "../images/smartmockups_kl7j7y1k.jpg";
const FirstSection = () => {
  return (
    <div class="container-fluid">
      <section class="py-5">
        <div class="container text-center">
          <h1
            className="text-center"
            style={{ color: "rgb(118, 102, 223)", fontSize: 50 }}
          >
            <i class="fa fa-users"></i> VALUABLE CLIENTS
          </h1>
          <p class="lead mb-5">
            we’ve had the pleasure of working with our valuable clients
          </p>
          <div>
            <div class="row align-items-center text-md-left mb-5">
              <div class="col-md-6 order-1 order-md-0">
                <img class="img-fluid" src={upnmImage} alt="" />
              </div>
              <div class="col-md-6 mb-4 mb-md-0">
                <span
                  class="display-4 mb-2"
                  style={{ color: "rgb(118, 102, 223)" }}
                >
                  kafeupnm
                </span>
                <h4 class="mb-4">Food Delivery Web App (PWA)</h4>
                <p>kafeupnm is a Food Delivery App like Uber Eats, Food Panda.</p>
              </div>
            </div>
            <div class="row align-items-center text-md-right mb-5">
              <div class="col-md-6 order-1">
                <img class="img-fluid" src={elabsImage} alt="" />
              </div>
              <div class="col-md-6 mb-4 mb-md-0">
                <span
                  class="display-3 mb-2"
                  style={{ color: "rgb(118, 102, 223)" }}
                >
                  e-labs
                </span>
                <h4 class="mb-4">Job Search Web App (PWA)</h4>
                <p>
                  e-Labs is the first platform dedicated to Data trainers and
                  training organizations.
                </p>
              </div>
            </div>
            {/* <div class="row align-items-center text-md-left mb-5">
              <div class="col-md-6 order-1 order-md-0">
                <img
                  class="img-fluid"
                  src="https://new.shuffle.dev/placeholder/pictures/bg_16-9.svg?primary=007bff"
                  alt=""
                />
              </div>
              <div class="col-md-6 mb-4 mb-md-0">
                <span class="display-3 mb-2">03</span>
                <h3 class="mb-4">Ongoing Support</h3>
                <p>
                  As with all innovative technologies, sometimes unpredictable
                  things will happen, and you can always count on our support to
                  solve issues for you.
                </p>
              </div>
            </div> */}
          </div>
        </div>
      </section>
    </div>
  );
};
// }

FirstSection.propTypes = {
  fluid: PropTypes.bool,
  // applies .container-fluid className
};

export default withRouter(FirstSection);
